var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhoneIconCircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_346",
    "data-name": "Rectangle 346",
    width: 32.397,
    height: 33.326,
    fill: "#4188f2"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6432",
    "data-name": "Groupe 6432",
    transform: "translate(-819 -5736)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_61",
    "data-name": "Ellipse 61",
    transform: "translate(819 5736)",
    fill: "#d9e7fd",
    stroke: "#4188f2",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 27.5,
    r: 26.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 27.5,
    r: 26,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6429",
    "data-name": "Groupe 6429",
    transform: "translate(831.129 5746.925)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_645",
    "data-name": "Groupe 645",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_871",
    "data-name": "Trac\\xE9 871",
    d: "M94.576,4.365A14.809,14.809,0,0,0,84.036,0a1.181,1.181,0,1,0,0,2.362A12.544,12.544,0,0,1,96.58,14.906a1.181,1.181,0,0,0,2.362,0A14.809,14.809,0,0,0,94.576,4.365",
    transform: "translate(-66.545 0)",
    fill: "#4188f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_872",
    "data-name": "Trac\\xE9 872",
    d: "M89.718,42.907a1.181,1.181,0,0,0,2.362,0,8.054,8.054,0,0,0-8.044-8.043,1.181,1.181,0,1,0,0,2.362,5.689,5.689,0,0,1,5.682,5.682",
    transform: "translate(-66.545 -28)",
    fill: "#4188f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_873",
    "data-name": "Trac\\xE9 873",
    d: "M20.559,41.384A3.567,3.567,0,0,0,17.4,43.272a1.181,1.181,0,1,0,1.949,1.334c.52-.76.755-.88,1.075-.864,1.022.12,5.048,3.07,5.451,3.993a1.22,1.22,0,0,1-.011.862,4.079,4.079,0,0,1-2.024,2.549,3.793,3.793,0,0,1-3.036-.1,33.392,33.392,0,0,1-10.95-7.13l0,0A33.4,33.4,0,0,1,2.737,32.975a3.793,3.793,0,0,1-.1-3.037,4.073,4.073,0,0,1,2.548-2.023,1.214,1.214,0,0,1,.86-.012c.926.4,3.876,4.43,4,5.441.017.331-.1.567-.863,1.085a1.181,1.181,0,0,0,1.332,1.951A3.564,3.564,0,0,0,12.4,33.219c-.1-1.886-3.773-6.884-5.527-7.529a3.572,3.572,0,0,0-2.44-.014A6.358,6.358,0,0,0,.488,28.954,6.082,6.082,0,0,0,.55,33.865,35.741,35.741,0,0,0,8.186,45.584l.025.024a35.73,35.73,0,0,0,11.7,7.623,7.018,7.018,0,0,0,2.637.55,5.416,5.416,0,0,0,2.274-.487A6.358,6.358,0,0,0,28.1,49.349a3.569,3.569,0,0,0-.011-2.434c-.647-1.758-5.644-5.429-7.534-5.532",
    transform: "translate(0 -20.455)",
    fill: "#4188f2"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIconCircle);
export default __webpack_public_path__ + "static/media/phone-icon-circle.9d6b31635c22ee4f0881ad687a5057d2.svg";
export { ForwardRef as ReactComponent };